import React from "react";

export default function MSAccess_Concat_And() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Concat_And</h1>
      <p>This is the MSAccess_Concat_And component generated from the SQL JSON.</p>
    </div>
  );
}
